import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";
import ProductSection from "./Sections/ProductSection.3.jsx";

const dashboardRoutes = [];

class LandingPage extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  buttonClick = (link) => {
    if (link === 'home') {
      this.props.history.push('/home')
    } else if (link === 'about') {
      this.props.history.push('/about')
    } else if (link === 'newsresources') {
      this.props.history.push('/newsresources')
    } else if (link === 'service') {
      this.props.history.push('/service')
    } else if (link === 'career') {
      this.props.history.push('/career')
    } else if (link === 'getintouch') {
      this.props.history.push('/getintouch')
    } else if (link === 'gallery') {
      this.props.history.push('/gallery')
    } else {
      this.props.history.push('/')
    }
  }
  render() {
    // const { expanded } = this.state;
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="SANDTON CONSULTING"
          rightLinks={<HeaderLinks onButtonClick={this.buttonClick} />}
          fixed
          changeColorOnScroll={{
            height: 10,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/landing-bg.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>&nbsp;&nbsp;Career</h1>
                {/* <h4>
                  Every landing page needs a small description after the big
                  bold title, that's why we added this text here. Add here all
                  the information that can make you or your product create the
                  first impression.
                </h4> */}
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          {/* <SectionPills /> */}
          <ProductSection />
          {/* <TeamSection1 /> */}
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/CareerPage/Article.3.jsx